export default "__VITE_ASSET__LT9O3qec__"